import React, { Component } from 'react';
import styled from 'styled-components';

const HeroContainer = styled.div`
  width:100vw;
  height:56.25vw;
  top:0;
  left:0;
  z-index:2;
  position: relative;
  overflow-x:hidden;
  transition:500ms all;
  box-shadow:0px 10px 10px rgba(0,0,0,0.5);
  overflow-y: hidden;
  background:#211e1f;
`

const BgVideo = styled.video`
  z-index:2;
  width:100%;
  // object-fit: cover;
  height:100%;
  
`

class Hero extends Component {

  render(){
    return (
      <HeroContainer className="heroFragment">
          <BgVideo controls
            poster={`${process.env.PUBLIC_URL}/assets/title_card.png`}
          >
            <source src={`${process.env.PUBLIC_URL}/assets/introduction_video.mp4`}/>
          </BgVideo>
        {/* <LogoContainer>
          <a href="http://senseable.mit.edu" target="_blank" rel="noopener noreferrer">
            <img className="logoImg" src={`${process.env.PUBLIC_URL}/mit_scl_logo_white.svg`} alt="Senseable City Lab Logo"/>
          </a>
        </LogoContainer> */}
        {/* <TitleContainer>
          <Title>
            Diversi<span>tree</span>
          </Title>
          <SubTitle>
            How diverse are urban forests<br></br>in eight global cities?
          </SubTitle>
        </TitleContainer> */}
      </HeroContainer>
    );
  }
}

export default Hero;